import { type MutationFunctionOptions } from '@apollo/client';

import { GetBankDetailsDocument } from 'common/hooks/useBankDetails/bankDetailsQuery.gql';
import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';
import { UserProfileQueryDocument } from 'features/Profile/Pages/Profile/hooks/useUserProfile/userProfileQuery.gql';

import {
  UpdateBankDetailsMutationDocument,
  type UpdateBankDetailsMutationMutation,
  type UpdateBankDetailsMutationMutationVariables,
} from './updateBankDetailsMutation.gql';

type Options = Omit<
  MutationFunctionOptions<
    UpdateBankDetailsMutationMutation,
    UpdateBankDetailsMutationMutationVariables
  >,
  'variables'
>;

export const useUpdateBankDetailsMutation = (options?: Options) => {
  const [mutate, hooks] = useErrorHandledMutation(
    UpdateBankDetailsMutationDocument,
    options,
  );

  const updateBankDetailsMutationDocument = (
    input: UpdateBankDetailsMutationMutationVariables['input'],
    mutationOptions?: Options,
  ) => {
    return mutate({
      ...mutationOptions,
      refetchQueries: [
        {
          query: GetBankDetailsDocument,
        },
        {
          query: UserProfileQueryDocument,
        },
      ],
      variables: { input },
    });
  };

  return [updateBankDetailsMutationDocument, hooks] as const;
};
